import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuthStore, useRealtimeChannel } from '@readsavor/auth';
// ============================================================================
// 依赖关系说明 (Dependency Explanation)
// ... (omitted for brevity)
// ============================================================================
/**
 * @class SubscriptionProvider
 * @description 订阅事件的“桥梁”提供者 (Bridge Provider)。
 *
 * @purpose
 * 该组件的核心职责是监听来自 Supabase Realtime 的、关于用户订阅状态和周期的实时变更事件。
 * 它通过监听 `user_subscriptions` 和 `user_subscription_cycles` 两张表，
 * 解决了因服务器端主动变更（如 webhook、计划任务）导致前端数据陈旧的问题。
 */
export const SubscriptionProvider = ({ children }) => {
    const { session } = useAuthStore();
    const queryClient = useQueryClient();
    const userId = session?.user?.id;
    // 设置频道
    const subscriptionsChannelName = userId ? `user-subscription-changes-${userId}` : null;
    const subscriptionsChannel = useRealtimeChannel(subscriptionsChannelName);
    const cyclesChannelName = userId ? `user-subscription-cycle-changes-${userId}` : null;
    const cyclesChannel = useRealtimeChannel(cyclesChannelName);
    // 效果一: 监听订阅状态表
    useEffect(() => {
        if (!subscriptionsChannel || !userId)
            return;
        const listener = subscriptionsChannel.on('postgres_changes', {
            event: '*',
            schema: 'public',
            table: 'user_subscriptions',
            filter: `user_id=eq.${userId}`,
        }, payload => {
            queryClient.invalidateQueries({ queryKey: ['subscription', { userId }] });
            queryClient.invalidateQueries({ queryKey: ['subscriptionCycle', { userId }] });
        });
        return () => {
            listener.unsubscribe();
        };
    }, [subscriptionsChannel, userId, queryClient]);
    // 效果二: 监听订阅周期表
    useEffect(() => {
        if (!cyclesChannel || !userId)
            return;
        const listener = cyclesChannel.on('postgres_changes', {
            event: '*',
            schema: 'public',
            table: 'user_subscription_cycles',
            filter: `user_id=eq.${userId}`,
        }, payload => {
            queryClient.invalidateQueries({ queryKey: ['subscriptionCycle', { userId }] });
        });
        return () => {
            listener.unsubscribe();
        };
    }, [cyclesChannel, userId, queryClient]);
    return _jsx(_Fragment, { children: children });
};
//# sourceMappingURL=SubscriptionProvider.js.map